import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  ADD_PRODUCT_START,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAILURE,
  UPDATE_PRODUCT_START,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_START,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  ADD_PRODUCT_COA_START,
  ADD_PRODUCT_COA_SUCCESS,
  ADD_PRODUCT_COA_FAILURE,
  DELETE_PRODUCT_COA_START,
  DELETE_PRODUCT_COA_SUCCESS,
  DELETE_PRODUCT_COA_FAILURE,
} from './actions';

export const transformProduct = response => ({
  id: response.id,
  name: response.product_product_name,
  productSKU: response.product_sku,
  batchNumber: response.product_batch_number,
  expirationDate: response.product_expiration_date,
  dateAdded: response.product_date_added,
  coas: response.product_coas.map(coa => ({
    id: coa.id,
    url: coa.product_coa_file,
  })),
});
export const transformProductError = response => ({
  isError: true,
  detail: response.product_coa_file ? response.product_coa_file[0] : 'Error',
  // messages: response, arr[Symbol.iterator] is not a function no time to look at this right now. Detail will show the error if it exists.
});
const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const accountAddProductReducer = createApiReducer(
  [ADD_PRODUCT_START, ADD_PRODUCT_SUCCESS, ADD_PRODUCT_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      products: [...state.data.products, transformProduct(payload)],
    };
  },
  error => transformProduct(_.get(error, 'payload.response', {}))
);

const accountDeleteProductReducer = createApiReducer(
  [DELETE_PRODUCT_START, DELETE_PRODUCT_SUCCESS, DELETE_PRODUCT_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      products: state.data.products.filter(d => d.id !== payload.id),
    };
  },
  error => transformProduct(_.get(error, 'payload.response', {}))
);

const updateProduct = (payload, state) => {
  const newProduct = transformProduct(payload);

  return {
    ...state.data,
    products: updateItem(state.data.products, 'id', newProduct.id, newProduct),
  };
};

const accountUpdateProductReducer = createApiReducer(
  [UPDATE_PRODUCT_START, UPDATE_PRODUCT_SUCCESS, UPDATE_PRODUCT_FAILURE],
  updateProduct,
  error => transformProduct(_.get(error, 'payload.response', {}))
);

const accountAddProductCOAReducer = createApiReducer(
  [ADD_PRODUCT_COA_START, ADD_PRODUCT_COA_SUCCESS, ADD_PRODUCT_COA_FAILURE],
  updateProduct,
  error => transformProductError(_.get(error, 'payload.response', {}))
);

const accountDeleteProductCOAReducer = createApiReducer(
  [
    DELETE_PRODUCT_COA_START,
    DELETE_PRODUCT_COA_SUCCESS,
    DELETE_PRODUCT_COA_FAILURE,
  ],
  updateProduct,
  error => transformProduct(_.get(error, 'payload.response', {}))
);

export const reducers = [
  accountAddProductReducer,
  accountUpdateProductReducer,
  accountDeleteProductReducer,
  accountAddProductCOAReducer,
  accountDeleteProductCOAReducer,
];
